import React, { useEffect } from 'react';
import { InfoMessage, Loading } from '@fasstech/middle-design-system';
import { defaultTo, find, isEmpty, pathOr, propEq } from 'ramda';
import { isRequiredSelect } from '@@viewHelpers/validations/index.js';
import {
  ControlledRadioButton,
  ControlledSelect
} from '@@viewCommonComponents/controlled/index.js';
import { isNilOrEmpty } from '@@serverHelpers/index.mjs';
import {
  isNotNil,
  isNotNilOrEmpty
} from '../../../../server/helpers/index.mjs';
import { CollegeEnum } from '@fasstech/oip-core/entities/enums';
import CcnOfferInfos from './CcnOfferInfos.jsx';

const CcnsList = ({
  ccns,
  loadingCcns,
  getMiddleText,
  form,
  noCCN,
  otherCcns,
  loadingOtherCcns,
  options,
  optionsOtherCcns,
  onSearchCcnOffer,
  ccnOffer,
  loadingCcnOffer,
  onSearchFlexiproduct
}) => {
  if (loadingCcns || loadingOtherCcns) {
    return <Loading />;
  }

  let ccn = form.watch('company.ccnRef');
  const collegeOptions = [
    {
      label: 'Ensemble du personnel',
      value: CollegeEnum.ALL
    },
    {
      label: 'Cadres',
      value: CollegeEnum.EXECUTIVE_EMPLOYEES
    },
    {
      label: 'Non cadres',
      value: CollegeEnum.EMPLOYEES
    }
  ];
  useEffect(() => {
    if (isNotNilOrEmpty(ccn)) {
      ccn = defaultTo(
        {},
        find(propEq('ref', ccn), ccns || []) ||
        find(propEq('ref', ccn), otherCcns || [])
      );
      const college =
        find(propEq('label', pathOr('', ['colleges', 0], ccn)))(
          collegeOptions
        ) || collegeOptions[0];
      onSearchCcnOffer(ccn.idcc, college.value);
      onSearchFlexiproduct(ccn.idcc);
    }
  }, [ccn]);

  return (
    <div className={'w-full'}>
      {isEmpty(ccns) && (
        <InfoMessage iconName={'lightbulb'}>
          {getMiddleText('ENTREPRISE_CCN_SANS_CCN_MESSAGE_INFO')}
        </InfoMessage>
      )}
      {noCCN ? (
        <div className={'flex w-full py-4 gap-4'}>
          <div className={'w-1/2'}>
            <InfoMessage iconName={'lightbulb'}>
              {getMiddleText('ENTREPRISE_CCN_NON_CCN_MESSAGE_INFO')}
            </InfoMessage>
          </div>
          <CcnOfferInfos
            loadingCcnOffer={loadingCcnOffer}
            showInfoMessage={!loadingCcnOffer && isNotNil(ccnOffer)}
            ccnOffer={ccnOffer}
            getMiddleText={getMiddleText}
          />
        </div>
      ) : (
        <>
          {!isEmpty(ccns) && isNilOrEmpty(otherCcns) && (
            <div className={'flex gap-4'}>
              <div className={'w-1/2'}>
                <ControlledRadioButton
                  className={'flex flex-col gap-2'}
                  name="company.ccnRef"
                  options={options}
                  rules={isRequiredSelect(options, false)}
                  form={form}
                  withIndicator={false}
                  isMultiline
                  data-testid="ENTREPRISE_CCNS_RADIO"
                />
              </div>
              <CcnOfferInfos
                loadingCcnOffer={loadingCcnOffer}
                showInfoMessage={
                  !loadingCcnOffer && isNotNilOrEmpty(ccn) && isNotNil(ccnOffer)
                }
                ccnOffer={ccnOffer}
                getMiddleText={getMiddleText}
              />
            </div>
          )}
          {!isNilOrEmpty(otherCcns) && (
            <div className={'flex w-full py-4 gap-4'}>
              <div className={'w-1/2'}>
                <ControlledSelect
                  label={getMiddleText(
                    'ENTREPRISE_CCN_CHOIX_AUTRE_CCN_BOUTON_LABEL'
                  )}
                  name="company.ccnRef"
                  options={optionsOtherCcns}
                  rules={isRequiredSelect(optionsOtherCcns, false)}
                  form={form}
                  withIndicator={false}
                  isMultiline
                  data-testid="ENTREPRISE_CCNS_SELECT"
                />
              </div>
              <CcnOfferInfos
                loadingCcnOffer={loadingCcnOffer}
                showInfoMessage={
                  !loadingCcnOffer && isNotNilOrEmpty(ccn) && isNotNil(ccnOffer)
                }
                ccnOffer={ccnOffer}
                getMiddleText={getMiddleText}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CcnsList;
